<!-- Crawl功能 -->
<template>
  <div
    class="PreviewWrap"
    v-loading="previewObj.CrawlLoading">
    <div class="previewHeader">{{$t('lang.Crawl')}}</div>
    <div class="SingularPreview">
      <div class="Preview">
        <iframe
          :src="previewObj.pvwUrl"
          frameborder="0"
          class="iframe"
          id="SingularPrevieW"
        ></iframe>
      </div>
    </div>
    <div class="CloseIcon" @click="ClosePreview">
      <i class="iconfont icon-a-closethick"></i>
    </div>
  </div>
</template>

<script>
import '@/assets/js/messenger.js'
import Bus from '@/assets/js/vueBus.js'
export default {
  props: {
    previewObj: {
      type: Object,
      default: () => ({
        syncSwitch: false,
        CrawlLoading: true
      })
    },
    CrawlLoading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      setBgc: false,
      menuUrl: '',
      childMountedTimer: null
    }
  },
  created () {
  },
  mounted () {
    this.judgeLoading()
    Bus.$on('goTemplateBlank', (obj, flag) => {
      // 编辑模板导致页面卡死
      this.ClosePreview()
    })
  },
  methods: {
    // 判断iframe是否加载成功
    judgeLoading () {
      this.$nextTick(() => {
        const menuDom = document.getElementById('SingularPrevieW')
        menuDom.onload = (e) => {
          setTimeout(() => {
            this.previewObj.CrawlLoading = false
          }, 1000)
        }
      })
    },
    ClosePreview () {
      this.previewObj.syncSwitch = false
    }
  }
}
</script>

<style scoped lang="less">
.PreviewWrap {
  position: absolute;
  bottom: 20px;
  right: calc(100% + 40px);
  height: 320px;
  border: 1px solid #252525;
  border-right: none;
  padding: 5px;
  background: #444;
  z-index: 3000;
  .previewHeader {
    text-align: left;
  }
  .SingularPreview {
    .Preview {
      width: 617px;
      height: 288px;
      background: #000000;
    }
    .Operation {
      display: flex;
      justify-content: flex-end;
      margin-top: 100px;
      .el-button {
        width: 100px;
        height: 36px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .Cancel {
        background: #cccccc;
      }
      .Save {
        background: #00cc66;
        border: 1px solid #0f620a;
      }
    }
  }
  .CloseIcon{
    position: absolute;
    top: 0px;
    right: 10px;
  }
}

</style>
